/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconPlayFilled8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlayFilled8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m6.417 5.154-3.5 2.021c-.889.513-2-.128-2-1.155V1.98a1.333 1.333 0 0 1 2-1.155l3.5 2.02a1.333 1.333 0 0 1 0 2.31Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconPlayFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlayFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m9.625 7.732-5.25 3.031c-1.333.77-3-.192-3-1.732V2.969c0-1.54 1.667-2.502 3-1.732l5.25 3.03c1.333.77 1.333 2.695 0 3.465Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconPlayFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlayFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m12.833 10.31-7 4.041c-1.778 1.026-4-.257-4-2.31V3.96c0-2.053 2.222-3.336 4-2.31l7 4.042c1.778 1.026 1.778 3.592 0 4.619Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconPlayFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlayFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m19.25 15.464-10.5 6.062c-2.667 1.54-6-.385-6-3.464V5.938c0-3.08 3.333-5.004 6-3.464l10.5 6.062c2.667 1.54 2.667 5.388 0 6.928Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconPlayFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlayFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconPlayFilled8 {...iconProps} />;
        case '12':
            return <IconPlayFilled12 {...iconProps} />;
        case '16':
            return <IconPlayFilled16 {...iconProps} />;
        case '24':
            return <IconPlayFilled24 {...iconProps} />;
        default:
            return <IconPlayFilled24 {...iconProps} />;
    }
});
